"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumWithValuesToArray = exports.enumToArray = exports.enumValues = void 0;
//workaround to get the enum values of non string enum object
const enumKeys = (enumObj) => Object.keys(enumObj).filter(k => typeof enumObj[k] === "number");
const enumValues = (enumObj) => enumKeys(enumObj).map(k => enumObj[k]);
exports.enumValues = enumValues;
// use for enums without values (defaults values: 0, 1, 2...)
function enumToArray(enumType) {
    const values = Object.values(enumType);
    return values.slice(values.length / 2);
}
exports.enumToArray = enumToArray;
// use for enums with values
function enumWithValuesToArray(enumType) {
    return Object.values(enumType);
}
exports.enumWithValuesToArray = enumWithValuesToArray;
//# sourceMappingURL=enumsUtils.js.map